import React, { useState } from 'react';
interface ImageGalleryProps {
  images: string[];
  name: string;
}
const ImageGallery: React.FC<ImageGalleryProps> = ({
  images,
  name
}) => {
  const [selectedImage, setSelectedImage] = useState(0);
  return <div className="space-y-4" data-id="element-13">
      {/* Main Image - Enlarged for emphasis */}
      <div className="relative w-full pb-[110%] md:pb-[100%] overflow-hidden rounded-lg bg-white shadow-md" data-id="element-14">
        <img src={images[selectedImage]} alt={name} className="absolute inset-0 h-full w-full object-cover object-center transition-opacity duration-300" data-id="element-15" />
      </div>
      {/* Thumbnail Images */}
      <div className="grid grid-cols-5 gap-2" data-id="element-16">
        {images.map((image, index) => <button key={index} onClick={() => setSelectedImage(index)} className={`relative pb-[100%] overflow-hidden rounded-lg ${selectedImage === index ? 'ring-2 ring-[#752F50]' : 'ring-1 ring-gray-200 hover:ring-[#752F50]'}`} data-id="element-17">
            <img src={image} alt={`${name} thumbnail ${index + 1}`} className="absolute inset-0 h-full w-full object-cover object-center" data-id="element-18" />
          </button>)}
      </div>
    </div>;
};
export default ImageGallery;